import React from 'react';

import { Card, Col, Row, Tag } from 'antd/lib';

import Avatar from '../../common/Avatar';
import ItemCompact from '../../common/ItemCompact';

import moment from 'moment';
import _ from 'lodash';

class VisorPersona extends React.Component {
  state = { visible: false };

  render() {
    if (!this.props.persona) {
      return null;
    }

    let { persona, tipos, acciones } = this.props;
    return (
      <div>
        <Card
          key={persona.num_doc}
          title={
            <>
              {_.map(tipos, tipo => {
                return tipo == 'requirente' ? (
                  <Tag key="requirente" color="#87d068">
                    REQUIRENTE
                  </Tag>
                ) : tipo == 'requerido' ? (
                  <Tag key="requerido" color="#f50">
                    REQUERIDO
                  </Tag>
                ) : tipo == 'denunciante' ? (
                  <Tag key="denunciante" color="#108ee9">
                    DENUNCIANTE
                  </Tag>
                ) : tipo == 'victima' ? (
                  <Tag key="victima" color="#87d068">
                    VICTIMA
                  </Tag>
                ) : (
                  <Tag key="agresor" color="#f50">
                    AGRESOR
                  </Tag>
                );
              })}
            </>
          }
          style={{ fontSize: 15 }}
          extra={acciones ? acciones : null}
        >
          <Col span={24}>
            <Card bordered={false} style={{ boxShadow: 'none' }}>
              <Row type={'flex'} justify={'start'} gutter={16}>
                <Col span={6}>
                  {_.includes(['DNI', 'D.N.I.'], persona.tipo_doc) ? (
                    <Avatar idPersona={persona._id} />
                  ) : (
                    <Avatar />
                  )}
                </Col>
                <Col span={18}>
                  <Row type={'flex'} justify={'start'} gutter={16}>
                    <ItemCompact
                      title={'Apellido y Nombre: '}
                      content={`${persona.apellido} ${persona.nombre}`}
                      fontSize={16}
                      span={12}
                    />

                    <ItemCompact
                      title={'Sexo: '}
                      content={`${persona.sexo}`}
                      span={4}
                    />
                  </Row>
                  <Row type={'flex'} justify={'start'} gutter={10}>
                    <ItemCompact
                      title={`${persona.tipo_doc}:`}
                      content={`${_.get(persona, 'num_doc', '')}`}
                      span={6}
                    />
                    <ItemCompact
                      title={'Fecha Nacimiento: '}
                      content={`${
                        persona.fecha_nacimiento
                          ? moment(persona.fecha_nacimiento).format(
                              'DD/MM/YYYY'
                            )
                          : 'Sin especificar'
                      }`}
                      span={6}
                    />
                    <ItemCompact
                      title={'Edad: '}
                      content={Math.floor(
                        moment(new Date()).diff(
                          moment(persona.fecha_nacimiento),
                          'years',
                          true
                        )
                      )}
                      span={6}
                    />
                    <ItemCompact
                      title={'Nacionalidad: '}
                      content={`${_.get(persona, 'nacionalidad', 'SIN DATOS')}`}
                      span={6}
                    />
                  </Row>

                  <Row type={'flex'} justify={'start'} gutter={10}>
                    <ItemCompact
                      title={`Ciudad:`}
                      content={`${_.get(persona, 'localidad.nombre', '')}`}
                      span={12}
                    />

                    <ItemCompact
                      title={'Direccion: '}
                      content={
                        persona.direccion_calle && persona.direccion_numero
                          ? persona.direccion_calle +
                            ' ' +
                            persona.direccion_numero
                          : 'SIN DATOS'
                      }
                      span={12}
                    />
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Card>
      </div>
    );
  }
}

export default VisorPersona;
